module.exports = __webpack_public_path__ + "img/fintech-based.624c6aa.png";